<template>
  <v-container>
    <div class="align-center pt-2">
      <span
        class="pl-2"
        style="font-size: 20px; font-weight: bold; color: #00a99d"
        >ผลตรวจทางห้องปฏิบัติการ (Laboratory)</span
      >
    </div>
    <v-data-table
      class="elevation-1 my-table mt-4 ml-1"
      style="background-color: #f6f6f6"
      :headers="headers"
      :items="item_laboratory"
      :hide-default-footer="true"
    >
      <template v-slot:body.prepend="props">
        <!-- ตรวจหาระดับน้ำตาลในเลือด -->
        <tr style="background-color: #f2fcf5">
          <td>
            <span style="color: #00a99d">ตรวจหาระดับน้ำตาลในเลือด</span>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <!-- ---- 1.1 ---- -->
        <tr>
          <td>
            <span>Fasting Blood Sugar (FBS)</span>
          </td>
          <td>
            <v-text-field
              v-model="props.items[0].Lab.Laboratory.bloodSugarLevel.fbs.result"
              @input="
                cal_reuslt(
                  'Lab',
                  'Laboratory',
                  'bloodSugarLevel',
                  'fbs',
                  props.items[0].Lab.Laboratory.bloodSugarLevel.fbs.result,
                  70,
                  99
                )
              "
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="text"
            ></v-text-field>
          </td>
          <td style="text-align: center">70-99 mg/dL</td>
          <td>
            <v-text-field
              v-model="
                props.items[0].Lab.Laboratory.bloodSugarLevel.fbs.summary
              "
              readonly
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลการสรุป"
              class="ma-2 textfield-sty"
              color="#00A99D"
            ></v-text-field>
          </td>
        </tr>

        <!-- ---- 1.2 ---- -->
        <tr>
          <td>
            <span>Glycated hemoglobin (HbA1C)</span>
          </td>
          <td>
            <v-text-field
              v-model="
                props.items[0].Lab.Laboratory.bloodSugarLevel.HbA1C.result
              "
              @input="
                cal_reuslt(
                  'Lab',
                  'Laboratory',
                  'bloodSugarLevel',
                  'HbA1C',
                  props.items[0].Lab.Laboratory.bloodSugarLevel.HbA1C.result,
                  4.0,
                  6.0
                )
              "
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="text"
            ></v-text-field>
          </td>
          <td style="text-align: center">4.0-6.0%</td>
          <td>
            <v-text-field
              v-model="
                props.items[0].Lab.Laboratory.bloodSugarLevel.HbA1C.summary
              "
              readonly
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลการสรุป"
              class="ma-2 textfield-sty"
              color="#00A99D"
            ></v-text-field>
          </td>
        </tr>
        <td class="table-border"></td>
        <!-- ---------- -->
        <!-- ตรวจหาระดับไขมันในเลือด -->
        <tr style="background-color: #f2fcf5">
          <td>
            <span style="color: #00a99d">ตรวจหาระดับไขมันในเลือด</span>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <!-- ---- 1.1 ---- -->
        <tr>
          <td>
            <span>Cholesterol</span>
          </td>
          <td>
            <v-text-field
              v-model="
                props.items[0].Lab.Laboratory.bloodLipidLevel.cholesterol.result
              "
              @input="
                cal_reuslt(
                  'Lab',
                  'Laboratory',
                  'bloodLipidLevel',
                  'cholesterol',
                  props.items[0].Lab.Laboratory.bloodLipidLevel.cholesterol
                    .result,
                  0,
                  200,
                  '<'
                )
              "
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
               type="text"
            ></v-text-field>
          </td>
          <td style="text-align: center">{{ props.items[0].value1 }}</td>
          <td>
            <v-text-field
              v-model="
                props.items[0].Lab.Laboratory.bloodLipidLevel.cholesterol
                  .summary
              "
              readonly
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลการสรุป"
              class="ma-2 textfield-sty"
              color="#00A99D"
            ></v-text-field>
          </td>
        </tr>
        <!-- ---- 1.2 ---- -->
        <tr>
          <td>
            <span>Triglyceride</span>
          </td>
          <td>
            <v-text-field
              v-model="
                props.items[0].Lab.Laboratory.bloodLipidLevel.triglyceride
                  .result
              "
              @input="
                cal_reuslt(
                  'Lab',
                  'Laboratory',
                  'bloodLipidLevel',
                  'triglyceride',
                  props.items[0].Lab.Laboratory.bloodLipidLevel.triglyceride
                    .result,
                  0,
                  150,
                  '<'
                )
              "
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="text"
            ></v-text-field>
          </td>
          <td style="text-align: center">{{ props.items[0].value2 }}</td>
          <td>
            <v-text-field
              v-model="
                props.items[0].Lab.Laboratory.bloodLipidLevel.triglyceride
                  .summary
              "
              readonly
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลการสรุป"
              class="ma-2 textfield-sty"
              color="#00A99D"
            ></v-text-field>
          </td>
        </tr>
        <!-- ---- 1.3 ---- -->
        <tr>
          <td>
            <span>HDL</span>
          </td>
          <td>
            <v-text-field
              v-model="
                props.items[0].Lab.Laboratory.bloodLipidLevel.HDLCholesterol
                  .result
              "
              @input="
                cal_reuslt(
                  'Lab',
                  'Laboratory',
                  'bloodLipidLevel',
                  'HDLCholesterol',
                  props.items[0].Lab.Laboratory.bloodLipidLevel.HDLCholesterol
                    .result,
                  0,
                  40,
                  '>'
                )
              "
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
               type="text"
            ></v-text-field>
          </td>
          <td style="text-align: center">{{ props.items[0].value3 }}</td>
          <td>
            <v-text-field
              v-model="
                props.items[0].Lab.Laboratory.bloodLipidLevel.HDLCholesterol
                  .summary
              "
              readonly
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลการสรุป"
              class="ma-2 textfield-sty"
              color="#00A99D"
            ></v-text-field>
          </td>
        </tr>
      </template>
      <template v-slot:item.listTreatment="{ item }">
        <td style="text-align: left">{{ item.listTreatment }}</td>
      </template>
      <template v-slot:item.treatment>
        <td>
          <v-text-field
            v-model="
              item_laboratory[0].Lab.Laboratory.bloodLipidLevel.LDLCholesterol
                .result
            "
            @input="
              cal_reuslt(
                'Lab',
                'Laboratory',
                'bloodLipidLevel',
                'LDLCholesterol',
                item_laboratory[0].Lab.Laboratory.bloodLipidLevel.LDLCholesterol
                  .result,
                0,
                130,
                '<'
              )
            "
            flat
            solo
            dense
            hide-details
            placeholder="ระบุผลตรวจ"
            class="ma-2 textfield-sty"
            color="#00A99D"
            @keypress="validateNumber"
             type="text"
          ></v-text-field>
        </td>
      </template>
      <template v-slot:item.value="{ item }">
        <td style="text-align: center">{{ item.value }}</td>
      </template>
      <template v-slot:item.summarize>
        <td>
          <v-text-field
            v-model="
              item_laboratory[0].Lab.Laboratory.bloodLipidLevel.LDLCholesterol
                .summary
            "
            readonly
            flat
            solo
            dense
            hide-details
            placeholder="ระบุผลการสรุป"
            class="ma-2 textfield-sty"
            color="#00A99D"
          ></v-text-field>
        </td>
      </template>
    </v-data-table>
    <!-- ----------------- -->

    <div class="align-center pt-6">
      <span
        class="pl-2"
        style="font-size: 20px; font-weight: bold; color: #00a99d"
        >ผลตรวจไทรอยด์ (Thyroid)</span
      >
    </div>

    <v-data-table
      class="elevation-1 my-table mt-4 ml-1"
      style="background-color: #f6f6f6"
      :headers="headers_thyroid"
      :items="thyroid"
      :hide-default-footer="true"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr>
            <td>{{ items[0].text }}</td>
            <td>
              <v-text-field
                v-model="item_laboratory[0].Lab.Laboratory.thyroid.tsh.result"
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลตรวจ"
                class="ma-2 textfield-sty"
                color="#00A99D"
                @keypress="validateNumber"
                @input="
                  cal_reuslt(
                    'Lab',
                    'Laboratory',
                    'thyroid',
                    'tsh',
                    item_laboratory[0].Lab.Laboratory.thyroid.tsh.result,
                    0.38,
                    5.33
                  )
                "
              ></v-text-field>
            </td>
            <td>{{ items[0].normal }}</td>
            <td>
              <v-text-field
                v-model="item_laboratory[0].Lab.Laboratory.thyroid.tsh.summary"
                readonly
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลการสรุป"
                class="ma-2 textfield-sty"
                color="#00A99D"
              ></v-text-field>
            </td>
          </tr>

          <tr>
            <td>{{ items[1].text }}</td>
            <td>
              <v-text-field
                v-model="
                  item_laboratory[0].Lab.Laboratory.thyroid.free_t4.result
                "
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลตรวจ"
                class="ma-2 textfield-sty"
                color="#00A99D"
                @keypress="validateNumber"
                @input="
                  cal_reuslt(
                    'Lab',
                    'Laboratory',
                    'thyroid',
                    'free_t4',
                    item_laboratory[0].Lab.Laboratory.thyroid.free_t4.result,
                    0.59,
                    1.54
                  )
                "
              ></v-text-field>
            </td>
            <td>{{ items[1].normal }}</td>
            <td>
              <v-text-field
                v-model="
                  item_laboratory[0].Lab.Laboratory.thyroid.free_t4.summary
                "
                readonly
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลการสรุป"
                class="ma-2 textfield-sty"
                color="#00A99D"
              ></v-text-field>
            </td>
          </tr>

          <tr>
            <td>{{ items[2].text }}</td>
            <td>
              <v-text-field
                v-model="
                  item_laboratory[0].Lab.Laboratory.thyroid.free_t3.result
                "
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลตรวจ"
                class="ma-2 textfield-sty"
                color="#00A99D"
                @keypress="validateNumber"
                @input="
                  cal_reuslt(
                    'Lab',
                    'Laboratory',
                    'thyroid',
                    'free_t3',
                    item_laboratory[0].Lab.Laboratory.thyroid.free_t3.result,
                    2.3,
                    4.9
                  )
                "
              ></v-text-field>
            </td>
            <td>{{ items[2].normal }}</td>
            <td>
              <v-text-field
                v-model="
                  item_laboratory[0].Lab.Laboratory.thyroid.free_t3.summary
                "
                readonly
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลการสรุป"
                class="ma-2 textfield-sty"
                color="#00A99D"
              ></v-text-field>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { EventBus } from "../../EventBus";
import HealthCheckCal from "../../services/health_check_cal";
export default {
  data() {
    return {
      headers: [
        {
          text: "รายการตรวจ",
          align: "center",
          sortable: false,
          value: "listTreatment",
        },
        {
          text: "ผลตรวจ",
          align: "center",
          sortable: false,
          value: "treatment",
        },
        {
          text: "ค่าปกติ",
          align: "center",
          sortable: false,
          value: "value",
        },
        {
          text: "สรุปผล",
          align: "center",
          sortable: false,
          value: "summarize",
        },
      ],
      item_laboratory: [
        {
          value1: "<200 mg/dL",
          value2: "<150 mg/dL",
          value3: ">40 mg/dL",
          listTreatment: "LDL",
          value: "<130 mg/dL",
          Lab: {
            Laboratory: {
              //ผลตรวจทางห้องปฏิบัติการ
              bloodSugarLevel: {
                //ตรวจหาระดับน้ำตาลในเลือด
                fbs: {
                  //Fasting Blood Sugar (FBS)
                  result: "", //ผลตรวจ
                  summary: "", //สรุปผล
                },
                HbA1C: {
                  result: "",
                  summary: "",
                },
              },
              bloodLipidLevel: {
                //ตรวจหาระดับไขมันในเลือด
                cholesterol: {
                  //cholesterol
                  result: "",
                  summary: "",
                },
                triglyceride: {
                  //Triglyceride
                  result: "",
                  summary: "",
                },
                HDLCholesterol: {
                  //HDL-Cholesterol
                  result: "",
                  summary: "",
                },
                LDLCholesterol: {
                  //LDL-Cholesterol
                  result: "",
                  summary: "",
                },
              },
              thyroid: {
                tsh: {
                  result: "",
                  summary: "",
                },
                free_t4: {
                  result: "",
                  summary: "",
                },
                free_t3: {
                  result: "",
                  summary: "",
                },
              },
            },
          },
        },
      ],

      headers_thyroid: [
        {
          text: "รายการตรวจ",
          align: "center",
          sortable: false,
          value: "exam",
        },
        {
          text: "ผลตรวจ",
          align: "center",
          sortable: false,
          value: "result",
        },
        {
          text: "ค่าปกติ",
          align: "center",
          sortable: false,
          value: "normal",
        },
        {
          text: "สรุปผล",
          align: "center",
          sortable: false,
          value: "summary",
        },
      ],
      thyroid: [
        {
          text: "TSH",
          value: "",
          normal: "0.38-5.33 uIU/mL",
        },
        {
          text: "Free T4",
          value: "",
          normal: "0.59-1.54 ng/dL",
        },
        {
          text: "Free T3",
          value: "",
          normal: "2.3-4.9 pg/mL",
        },
      ],
    };
  },
  created() {
    this.detailAll();
  },

  methods: {
    cal_reuslt(
      key_1,
      key_2,
      key_3,
      key_4,
      data,
      min = 0,
      max = 0,
      operator = null
    ) {
      if (data == "") {
        this.item_laboratory[0][`${key_1}`][`${key_2}`][`${key_3}`][
          `${key_4}`
        ].result = "";
        this.item_laboratory[0][`${key_1}`][`${key_2}`][`${key_3}`][
              `${key_4}`
            ].summary = ""
        return;
      } else {
        data = parseInt(data, 10);
        data = data.toString();
        this.item_laboratory[0][`${key_1}`][`${key_2}`][`${key_3}`][
          `${key_4}`
        ].result = data;
        let result = null;
        if (operator === "<" || operator === ">") {
          if (operator === "<") {
            this.item_laboratory[0][`${key_1}`][`${key_2}`][`${key_3}`][
              `${key_4}`
            ].summary =
              this.item_laboratory[0][`${key_1}`][`${key_2}`][`${key_3}`][
                `${key_4}`
              ].result.length > 0
                ? data < max
                  ? "ปกติ"
                  : "ผิดปกติ"
                : "";
          } else if (operator === ">") {
            this.item_laboratory[0][`${key_1}`][`${key_2}`][`${key_3}`][
              `${key_4}`
            ].summary =
              this.item_laboratory[0][`${key_1}`][`${key_2}`][`${key_3}`][
                `${key_4}`
              ].result.length > 0
                ? data > max
                  ? "ปกติ"
                  : "ผิดปกติ"
                : "";
          }
        } else if (
          data ||
          (data === "" &&
            this.item_laboratory[0][`${key_1}`][`${key_2}`][`${key_3}`][
              `${key_4}`
            ].summary)
        ) {
          result = HealthCheckCal("item_laboratory", data, {
            min: min,
            max: max,
          });
          this.item_laboratory[0][`${key_1}`][`${key_2}`][`${key_3}`][
            `${key_4}`
          ].summary =
            this.item_laboratory[0][`${key_1}`][`${key_2}`][`${key_3}`][
              `${key_4}`
            ].result.length < 1
              ? ""
              : result.result;
        }
      }
    },
    removeLeadingZero(event) {
      let value = event.target.value;

      // ลบเลข 0 ด้านหน้าถ้ามีข้อมูลอยู่แล้ว
      if (/^0\d/.test(value)) {
        value = value.replace(/^0+/, ""); // ลบ 0 ตัวแรกออก
      }

      // ถ้าผู้ใช้ป้อน "0" ที่หน้าสุด ให้ลบออกหรือเป็นค่าว่าง
      if (value === "0") {
        value = "";
      }
      console.log("🚀 ~ removeLeadingZero ~ value:", value);
      // this.item_laboratory[0][`${key_1}`][`${key_2}`][`${key_3}`][
      //   `${key_4}`
      // ].result = value;
    },
    detailAll() {
      EventBus.$on("detailAll_GetOneForm", (item) => {
        if (item !== undefined && item !== null) {
          this.item_laboratory[0].Lab.Laboratory = item.laboratory;
        } else {
          this.item_laboratory = [
            {
              value1: "mg/dL (<200)",
              value2: "mg/dL (<150)",
              value3: ">40 mg/dL",
              listTreatment: "LDL-Cholesterol",
              value: "<130 mg/dL",
              Lab: {
                Laboratory: {
                  //ผลตรวจทางห้องปฏิบัติการ
                  bloodSugarLevel: {
                    //ตรวจหาระดับน้ำตาลในเลือด
                    fbs: {
                      //Fasting Blood Sugar (FBS)
                      result: "", //ผลตรวจ
                      summary: "", //สรุปผล
                    },
                  },
                  bloodLipidLevel: {
                    //ตรวจหาระดับไขมันในเลือด
                    cholesterol: {
                      //cholesterol
                      result: "",
                      summary: "",
                    },
                    triglyceride: {
                      //Triglyceride
                      result: "",
                      summary: "",
                    },
                    HDLCholesterol: {
                      //HDL-Cholesterol
                      result: "",
                      summary: "",
                    },
                    LDLCholesterol: {
                      //LDL-Cholesterol
                      result: "",
                      summary: "",
                    },
                  },
                },
              },
            },
          ];
        }
      });
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      const input = event.target;
      let value = input._value;
      let cursorPosition = input.selectionStart;
      if (keyCode < 46 || keyCode > 57 || keyCode == 47) {
        event.preventDefault();
      }

      if (event.key === "." && value.includes(".")) {
        event.preventDefault();
        return;
      }

      if (event.key === "0" && value == "") {
        input.value = "0";
        return;
      }

      if (event.key === "0" && value[0] == "0") {
        input.value = "";
        return;
      }

      if (event.key == "0" && cursorPosition === 0) {
        input.value = "0";
        return;
      }
      setTimeout(() => {
        if (/^0\d/.test(input.value)) {
          input.value = input.value.replace(/^0+/, "");
        }
      }, 0);
    },
  },
  beforeDestroy() {
    EventBus.$off("detailAll_GetOneForm", this.detailPhysicalExam);
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");
.my-table thead th {
  background: #00a99d !important;
  color: #ffffff !important;
  &:first-child {
    border-radius: 10px 0 0 0;
  }
  &:last-child {
    border-radius: 0 10px 0 0;
  }
}
.textfield-sty {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
.btn-sty {
  border-radius: 10px;
}
.text-cennter {
  text-align: center;
}

/* สำหรับ Chrome, Edge และเบราว์เซอร์ที่ใช้ WebKit */
::v-deep input[type="number"]::-webkit-inner-spin-button,
::v-deep input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* สำหรับ Firefox */
::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

::v-deep .v-input input {
  line-height: 1.8rem;
  text-indent: 4px;
}
::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.8rem !important;
}
</style>
